package br.com.texeratx.boardgametimeapp.ui.screens.expansions.list

import br.com.texeratx.boardgametimeapp.core.i18n.LanguageManager
import br.com.texeratx.boardgametimeapp.data.model.expansion.ExpansionDTO
import br.com.texeratx.boardgametimeapp.domain.usecases.expansions.GetAllExpansionsUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.GetGamesSimpleUseCase
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class ExpansionsViewModel(
    private val getAllExpansions: GetAllExpansionsUseCase,
    private val getGamesSimple: GetGamesSimpleUseCase,
    private val lang: LanguageManager
) : ScreenModel {

    val state = MutableStateFlow(ExpansionsUiState())

    fun load() {
        screenModelScope.launch {
            state.value = state.value.copy(isLoading = true, error = null)

            val gamesResult = getGamesSimple()
            val expansionsResult = getAllExpansions()

            val games = gamesResult.getOrElse {
                state.value = state.value.copy(
                    isLoading = false,
                    error = lang.strings.value.errorLoadingGames
                )
                return@launch
            }

            val expansions = expansionsResult.getOrElse {
                state.value = state.value.copy(
                    isLoading = false,
                    error = lang.strings.value.errorLoadingExpansions
                )
                return@launch
            }

            val gameNameById = games.associate { it.id to it.name }

            val grouped: Map<Long, List<ExpansionDTO>> = expansions.groupBy { it.gameId }

// ordena pelas chaves (gameId) sem usar toSortedMap()
            val groups = grouped.keys
                .sorted()
                .map { gameId ->
                    val list = grouped[gameId].orEmpty()

                    ExpansionGroupUi(
                        gameId = gameId,
                        gameName = gameNameById[gameId] ?: "Jogo #$gameId",
                        items = list
                            .sortedBy { it.name }
                            .map { e ->
                                ExpansionItemUi(
                                    id = e.id,
                                    name = e.name,
                                    imageUrl = e.imageUrl,
                                    bggUrl = e.bggUrl
                                )
                            }
                    )
                }

            state.value = state.value.copy(isLoading = false, groups = groups)
        }
    }
}
